import { createI18n } from 'vue-i18n'

import en from './locales/en.json'

/**
 * English-first per admin-portal-specification.md §2 ("Portal is
 * English-first internally; still externalized"), wired for future locales
 * — add a new `locales/<code>.json` + entry in `messages` and
 * `stores/ui.ts`'s `SUPPORTED_LOCALES`.
 */
export const i18n = createI18n({
  legacy: false, // Composition API mode, required for useI18n() in <script setup>
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en },
})
